import reducerFunctions from './_utils/reducerFunctions';
const resourceType = 'transactions';
const initialState = {
    init: false,
    error: false,
    loading: false,
    data: null
};

export default function (state = initialState, action) {
    switch(action.type) {
        default:
            return reducerFunctions(resourceType, initialState, state, action)
    }
}
